import React from 'react';

import {Button, Anchor} from '@newsela/angelou';

export const SignInLink = React.forwardRef((props, ref) => {
  SignInLink.displayName = 'SignInLink';
  const searchParams = new URLSearchParams({next: window.location.href});

  return (
    <Anchor
      dataProps={{'data-qa-selector': 'navigation_signin_link'}}
      href={`/signin?${searchParams.toString()}`}
      ref={ref}
      styleAnchorAsButton={{
        legacy_flavor: Button.legacy_flavor.solid,
        legacy_statusColor: Button.legacy_statusColor.primary,
      }}
    >
      Sign In
    </Anchor>
  );
});

export default SignInLink;
